import { createFileRoute } from '@tanstack/react-router';
import { FormWorkspace } from '@web/modules/forms/workspace/form-workspace';

/**
 * A form takes the whole screen (spec 026, §5): its own bar with the way back, the name, the
 * tabs (Editor · Opções · Compartilhar · Respostas), "Ver" and "Publicar".
 */
export const Route = createFileRoute('/_app/capture/forms/$formId')({
  component: function FormRoute() {
    const { formId } = Route.useParams();
    return <FormWorkspace formId={formId} />;
  },
});
